export default __webpack_public_path__ + "static/src/assets/images/icons/light/export_icon_light.png";